<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :title="$t('offers.edit_offer')">
        <template v-slot:preview>
          <b-form @submit="onSubmit" @reset="onReset">
            <b-row>
              <b-col md="6">
                <b-form-group
                    :label="$t('new_offer.project_name_')"
                    :description="$t('new_offer.project_name_description')"
                >
                  <b-input-group>
                    <b-form-input
                        class="form-control form-control-solid"
                        v-model="form.name"
                        type="text"
                        required
                        :placeholder="$t('new_offer.project_name')"
                    ></b-form-input>

                  </b-input-group>
                </b-form-group>
                <b-form-group
                    label="Kampanya Durumu"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="form.campaign_status"
                      :options="campaign_status"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Buton Yazısı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Buton Yazısı"
                      v-model="form.button_text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Anasayfa Başlığı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Anasayfa Başlığı"
                      v-model="form.homepage_title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Detay Sayfası Başlığı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Detay Sayfası Başlığı"
                      v-model="form.detail_page_title"
                  ></b-form-input>
                </b-form-group>

                <b-row>
                  <b-col lg="12">
                    <h3 class="font-size-lg text-dark font-weight-bold mb-6">Kampanya Görseli</h3>
                    <div class="separator separator-dashed my-6"></div>
                    <b-form-group label="940x300px" label-for="file-default" label-cols-sm="2">
                      <b-form-file id="file-default" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                    </b-form-group>

                    <img style="width:100%;border-radius: 8px;" src="http://cdn.napolyon.com/napolyon/profilgorev/PB_kisiselbilgiler_750x330.png" alt="">
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-form-group label="Kampanya Adı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Kampanya Adı"
                      v-model="form.campaign_name"
                      @input="changeItName($event)"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Kampanya URL">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Kampanya URL"
                      v-model="form.slug"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                    label="Anket Türü"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="form.survey_type"
                      :options="survey_types"
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                    label="Bitiş Bantı"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="form.end_tape"
                      :options="end_tapes"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Buton URL">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Buton URL"
                      v-model="form.button_url"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Anasayfa Açıklaması">
                  <b-form-textarea
                      class="form-control form-control-solid"
                      name="name"
                      placeholder="Anasayfa Açıklaması"
                      v-model="form.homepage_desc"
                  ></b-form-textarea>
                </b-form-group>

                <b-row>
                  <b-col lg="6">
                    <b-form-group label="Başlangıç Tarihi" label-for="input-2">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="date"
                          required
                          v-model="form.date"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Bitiş Tarihi" label-for="input-2">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="date"
                          required
                          v-model="form.date"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-form-checkbox
                          id="checkbox-1"
                          name="checkbox-1"
                          v-model="form.winners_campaign"
                          unchecked-value="not_accepted"
                          class="mb-5"
                      >
                        Kazananlar Kampanyası Var
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-12"
                          id="checkbox-12"
                          name="checkbox-12"
                          v-model="form.related_survey"
                          unchecked-value="not_accepted"
                          class="mb-5"
                      >
                        İlişkili Anket Var
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="İlişkili Anket">
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.survey"
                          :options="surveys"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Wave">
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.wave"
                          :options="waves"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-13"
                          id="checkbox-13"
                          name="checkbox-13"
                          v-model="form.mini_poll"
                          unchecked-value="not_accepted"
                      >
                        CRM Mini Anket
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-14"
                          id="checkbox-14"
                          name="checkbox-14"
                          v-model="form.mobile_view"
                          unchecked-value="not_accepted"
                      >
                        Mobilde Göster
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-14"
                          id="showDorinsight"
                          name="showDorinsight"
                          :v-model="true"
                          unchecked-value="not_accepted"
                      >
                        Dorinsight'ta Göster
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12" class="mt-10">
                <RichTextArea></RichTextArea>
              </b-col>
              <b-col md="12" class="mt-10 mb-10">
                <b-tabs content-class="mt-3">
                  <b-tab title="TAB 1" active>
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          v-model="form.tab1_title"
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>

                  </b-tab>
                  <b-tab title="TAB 2">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          v-model="form.tab2_title"
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                  <b-tab title="TAB 3">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          v-model="form.tab3_title"
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                  <b-tab title="TAB 4">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          v-model="form.tab4_title"
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <!-- Message Share Campaign -->
            <b-row>
              <b-col lg="12" class="mt-7 mb-7">
                <div class="h6 mb-3 table-vertical-center">
                  <b-form-checkbox
                      id="message-share"
                      v-model="message_share_status"
                      name="message_share_status"
                      :unchecked-value="false"
                      class="d-inline-flex pt-4px"
                      size="md"
                  >
                  </b-form-checkbox>
                  <label for="message-share">{{ $t('campaigns.message_share_campaign') }}</label>
                </div>
                <div class="separator separator-dashed"></div>
              </b-col>
              <b-row v-if="message_share_status">
                <b-col lg="6">
                  <b-form-group label="Kampanya Sayfası">
                    <b-input-group>
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          disabled
                          value="/Mesaj-Paylas/napolyon-cmpcampaign-template"
                          placeholder="Kampanya Adı"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary">Kopyala</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-row>
                    <b-col lg="6">
                      <b-form-group label="Tanıtım Başlığı">
                        <b-form-input
                            class="form-control form-control-solid"
                            type="text"
                            v-model="message_campaign_form.promotional_title"
                            placeholder="Tanıtım Başlığı"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-group
                          label="Maksimum Katılım Hakkı"
                      >
                        <b-form-select
                            class="form-control form-control-solid"
                            v-model="message_campaign_form.max_participation"
                            :options="message_campaign.max_participations"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="12">
                      <b-form-group label="Maksimum Katılım SQL">
                        <b-form-textarea
                            class="form-control form-control-solid"
                            placeholder="SQL Kodu"
                            v-model="message_campaign_form.sql_code"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-checkbox
                          unchecked-value="not_accepted"
                          v-model="message_campaign_form.image"
                      >
                        Resimli?
                      </b-form-checkbox>
                    </b-col>
                    <b-col lg="6">
                      <b-form-checkbox
                          unchecked-value="not_accepted"
                          v-model="message_campaign_form.confirm_required"
                      >
                        Onay Gerekli?
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                  <RichTextArea></RichTextArea>
                </b-col>
              </b-row>
            </b-row>
            <!-- Message Share Campaign -->
          </b-form>
        </template>
        <template v-slot:foot>
          <b-button type="submit" v-on:click="submit" :disabled="form.submit" variant="primary" class="fa-pull-right"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
        </template>
      </dashboard-box>
    </div>
  </div>

</template>
<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import RichTextArea from "@/view/pages/vue-bootstrap/RichTextArea";

export default {
  name: "EditCrmOffer",
  components: { DataTable, DashboardBox, RichTextArea },
  methods: {
    HideModal(){
      window.alert('Tebrikler')
    },
    changeIt(data,input) {
      if (input == "message_share_status"){
        if (data === true){
          this.message_share_status = true;
        }else{
          this.message_share_status = false;
        }
      }
    },
    changeItName(){
      this.form.slug = _.kebabCase(this.form.campaign_name);
    },
    onSubmit(evt) {
      evt.preventDefault();
      var json_data = JSON.stringify(this.form)
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    submit: function (e) {
      e.preventDefault();
      Swal.fire({
        title: "",
        text: "Teklif kartı başarıyla güncellendi!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Tamam",
      });
    }
  },
  data() {

    return {
      form: {
        name: 'Bilyoner 2020 Pazar Araştırması',
        campaign_name: '2020 Bilyoner Pazar',
        slug: '2020 bilyoner-pazar',
        url: '2020 bilyoner-pazar',
        campaign_status : 'Test Modu',
        end_tape : 'Sarı',
        survey : 'Limonist (P12929)',
        wave : 1,
        button_text : 'Hemen Tıkla',
        button_url : '#',
        homepage_desc : 'Anasayfa Test Açıklaması',
        homepage_title : 'Anasayfa Test Başlığı',
        detail_page_title : 'Detay Sayfası Test Başlığı',
        date : '2020-12-11',
        winners_campaign: true,
        related_survey : true,
        mini_poll : true,
        mobile_view : true,
        tab1_title : "Tab 1 Test Başlığı",
        tab2_title : "Tab 2 Test Başlığı",
        tab3_title : "Tab 3 Test Başlığı",
        tab4_title : "Tab 4 Test Başlığı",
        target_group : 'SQL * ...',
        survey_type : 'Base Link\'li Anket'
      },
      message_campaign_form : {
        name : 'Yeni Yıl 2019',
        promotional_title: 'Örnek Tanıtım Başlığı',
        selected_campaign: 'Caps',
        max_participation: 2,
        sql_code: 'Örnek SQL Kodu * ....',
        image : true,
        confirm_required : true,
      },
      message_campaign : {
        campaigns: [{ text: this.$t('general.select'), value: null } , 'Napolyon CMP Campaign Template', 'Caps', 'Bilgi Yarışması Eylül 2015 Kazananlar', '100.000 Nap Puan Ekim', 'Eşleştirme Eylül Kazananlar', 'Ekim Reeder'],
        max_participations: [{ text: this.$t('general.select'), value: null } , 1,2,3,4,5,6,7,8],
      },
      message_share_status : true,
      campaign_status: [{ text: this.$t('general.select'), value: null } , 'Test Modu','Aktif', 'Pasif'],
      end_tapes: [{ text: this.$t('general.select'), value: null } , 'Mavi','Sarı', 'Kırmızı'],
      surveys : [{ text: this.$t('general.select'), value: null } , 'Limonist (P12929)','Deneme (P12928)', 'Test (P12927)'],
      waves: [{ text: this.$t('general.select'), value: null } , '1','2', '3','4','5','6'],
      survey_types : [
        { text: this.$t('general.select'), value: null },
        'Feedback Server Anketi',
        'Base Link\'li Anket',
        'Havuz Link\'li Anket',
        'SPSS/PASW Anketi',
        'Müşteri Listesine Anket (SPSS)',
        'SSI Web Anketi',
        'Müşteri Listesine Anket (SSI)'
      ]
    }
  },
  mounted() {

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_1'), route: "alert" },
      { title: "Bilyoner 2020 Pazar Araştırması" }
    ]);
  }
}
</script>

<style scoped>
.editor__content .ProseMirror:focus {
  outline: none !important;
}
.pt-4px{
  padding-top: 4px;
}
</style>